
import React, { Component } from 'react';

class WhiteSpace extends Component {

    render() {
        return (
            <div className={`white-space-${this.props.height}`}></div>
        );
    };

}

export default WhiteSpace;


// WEBPACK FOOTER //
// ./src/components/WhiteSpace/whiteSpace.js